import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { MapPin } from 'lucide-react';

const Hero = () => {
  const { language } = useLanguage();

  const translations = {
    en: {
      tagline: "Authentic East Coast Deli",
      subtitle: "In the Heart of Bordeaux",
      description: "Experience the bold flavors of New York's iconic delis, crafted with passion and served with soul.",
      cta: "View Menu",
      location: "9 Rue Parlement Saint-Pierre, Bordeaux"
    },
    fr: {
      tagline: "Sandwicherie Américaine Authentique",
      subtitle: "Au Cœur de Bordeaux",
      description: "Découvrez les saveurs audacieuses des delis emblématiques de New York, préparées avec passion et servies avec amour.",
      cta: "Voir le Menu",
      location: "9 Rue Parlement Saint-Pierre, Bordeaux"
    }
  };

  const t = translations[language];

  const scrollToMenu = () => {
    const element = document.getElementById('menu');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a1929]/85 via-[#0a1929]/75 to-[#0a1929]/90 z-10"></div>
        <img 
          src="https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/9r7e9824_WhatsApp%20Image%202025-12-28%20at%205.23.22%20PM%20%281%29.jpeg" 
          alt="The Royal BEC" 
          className="w-full h-full object-cover"
        />
      </div>

      {/* Content */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8 animate-fadeIn">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_sids-sandwich-spot/artifacts/krpy34tr_Final_Logo_Sids_Deli-removebg-preview.png" 
              alt="Sid's Deli" 
              className="h-48 w-auto drop-shadow-2xl"
            />
          </div>

          {/* Taglines */}
          <div className="space-y-4">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#c9a961] tracking-wide">
              {t.tagline}
            </h1>
            <p className="text-2xl sm:text-3xl md:text-4xl text-white/90 font-light italic">
              {t.subtitle}
            </p>
          </div>

          {/* Description */}
          <p className="text-lg sm:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed">
            {t.description}
          </p>

          {/* CTA Button */}
          <div className="pt-6">
            <Button
              onClick={scrollToMenu}
              size="lg"
              className="bg-[#c9a961] hover:bg-[#d4b975] text-[#0a1929] font-bold text-lg px-10 py-6 transition-all transform hover:scale-105 shadow-lg"
            >
              {t.cta}
            </Button>
          </div>

          {/* Location */}
          <div className="pt-8 flex items-center justify-center space-x-2 text-[#c9a961]/80">
            <MapPin className="w-5 h-5" />
            <span className="text-sm sm:text-base">{t.location}</span>
          </div>
        </div>
      </div>

      {/* Decorative Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0 z-10">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full h-16 sm:h-24">
          <path fill="#0a1929" fillOpacity="1" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;